<template lang="html">
  <div>
    <!-- Infobar -->
    <div class="py-1 px-4 flex w-full relative bg-black h-8">
      <div class="flex items-center w-2/5">
        <div
          class="uppercase text-red-600 font-bold flex items-center"
          v-show="isRecording"
        >
          <svg
            class="h-6 w-6 fill-current mr-2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M10 3a7 7 0 1 0 .001 13.999A7 7 0 0 0 10 3z" />
          </svg>
          <div class="ml-1">REC</div>
        </div>
      </div>
      <div id="recordingTime" class="text-lg text-white text-center w-1/5" v-if="isMirrorPlus">
        00:00:00
      </div>
      <div
        id="cameraAudioOff"
        class="w-1/5 text-white uppercase text-right text-sm pt-1"
      >
        Camera audio off
      </div>
      <div
        class=" w-1/5 uppercase text-red-600 font-bold pt-1 pl-1 text-right"
        v-show="!isHighDataModeOn"
      >
        LOW DATA MODE
      </div>
    </div>
    <!-- Infobar END -->
    <div class="relative bg-black">
      <!-- Info if the session is suspended-->
      <div
        class="bg-red-500 flex items-center w-full absolute top-0 left-0 justify-center z-10" v-show="sessionSuspended">
        <div class="z-10 text-white text-lg leading-9 font-medium py-1">
        The session is paused. To resume it please tap "Resume session" above.
        </div>
      </div>

      <!-- Placeholder -->
      <div
        class="flex items-center w-full h-full absolute top-0 left-0 justify-center"
        id="viewportPlaceholderText"
      >
        <div
          class="z-10 text-shadow-md text-white text-4xl leading-9 font-bold"
        >
          "The best camera <br />
          is the one you <br />
          have with you"
        </div>
      </div>
      <!-- Placeholder END -->
      <div id="videoWrapper" class="transition-all">
        <div id="mask-before" class="absolute z-30 opacity-50 bg-black"></div>
        <div id="mask-after" class="absolute z-30 opacity-50 bg-black"></div>
        <video
          id="localVideo"
          autoplay
          playsinline
          muted
          class="left-0 right-0 mx-auto bg-black transform transition-all duration-300"
          style="height: 101%;"
          :class="getRotationAngle"
          v-show="demoModeOn == false"
        ></video>
        <h1
          class="text-white left-0 bottom-0 absolute mb-5 ml-5"
          v-show="demoModeOn"
        >
          Demo mode is currently on
        </h1>
      </div>
    </div>
    <!-- Controlbar -->
    <viewport-controls
      ref="viewportControls"
      @is-recording="isRecording = $event"
      @create-take-folder="$emit('create-take-folder')"
      @rotate-viewport="rotateViewport()"
      @mask-viewport="maskViewport($event)"
      :room-activated="roomActivated"
      :tempHideCamera="tempHideCamera"
      :isMirrorPlus="isMirrorPlus"
    ></viewport-controls>
  </div>
</template>
<script>
import Plyr from "plyr";
import commandsManager  from "../general/CommandsManager";

export default {
  props: {
    demoModeOn: {
      type: Boolean,
      required: true,
    },
    isHighDataModeOn: {
      type: Boolean,
      required: true,
    },
    roomActivated: {
      type: Boolean,
      required: false,
    },
    tempHideCamera: {
      type: Boolean,
      required: true,
    },
    isMirrorPlus: {
      type: Boolean,
      required: true,
    },
    sessionSuspended: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    setRollSceneShot(roll, scene, shot) {
      this.$refs.viewportControls.setRollSceneShot(roll, scene, shot);
    },
    maskViewport(aspectRatio) {
      this.drawMaskViewport(aspectRatio);
      commandsManager.sendAllCommand("mask_viewport", { aspectRatio: aspectRatio });
      this.aspectRatio = aspectRatio;
    },
    drawMaskViewport(aspectRatio){
        let ratio = aspectRatio.split(":").reduce((a, b) => a/b);
        // left right
        const maskBefore = $("#mask-before")
        const maskAfter = $("#mask-after")

        const verticalClassListLeft = "inset-y-0 left-0"
        const verticalClassListRight = "inset-y-0 right-0"
        if (ratio < 16 / 9) {
            maskBefore.addClass(verticalClassListLeft).removeClass("inset-x-0 top-0");
            maskAfter.addClass(verticalClassListRight).removeClass("inset-x-0 bottom-0");
            maskBefore.css("height", "initial");
            maskAfter.css("height", "initial");
            const height = maskBefore.height();
            maskBefore.css("width", (height * (16 / 9 - ratio / 1)) / 2);
            maskAfter.css("width", (height * (16 / 9 - ratio / 1)) / 2);
        } else {
            // top bottom
            maskBefore
            .removeClass(verticalClassListLeft)
            .addClass("inset-x-0 top-0");
            maskAfter
            .removeClass(verticalClassListRight)
            .addClass("inset-x-0 bottom-0");
            maskBefore.css("width", "initial");
            maskAfter.css("width", "initial");
            const width = maskBefore.width();
            maskBefore.css("height", (width / 2) * (9 / 16 - 1 / ratio));
            maskAfter.css("height", (width / 2) * (9 / 16 - 1 / ratio))
        }
    },
    rotateViewport() {
      this.angle = this.angle + 90;
      if (this.angle >= 360) this.angle = 0;
      commandsManager.sendAllCommand("rotate_viewport", { angle: this.angle });
    },
    resizeVideo() {
      const videoEl = $("#localVideo");
      const videoElWrapper = $("#localVideo").parents(".plyr--video");
      const rotation = parseInt(this.angle);
      if (rotation == 0 || rotation == 180) {
        videoEl.width(videoElWrapper.width());
      }
      if (rotation == 90 || rotation == 270) {
        videoEl.width(videoElWrapper.height());
      }
    },
  },
  computed: {
    getRotationAngle() {
      this.resizeVideo();
      if (this.angle == 0) {
        return "";
      }
      if (this.angle == 90) {
        return "-rotate-90";
      }
      if (this.angle == 180) {
        return "-rotate-180";
      }
      if (this.angle == 270) {
        return "-rotate-270";
      }
    },
  },
  data() {
    return {
      angle: 0,
      aspectRatio: '16:9',
      isRecording: false,
    };
  },
  mounted() {
    // resize video when window resizes
    window.addEventListener("resize", this.resizeVideo);
    const videoEl = $("#localVideo");
    const controls = {
      clickToPlay: false,
      ratio: "16:9",
      storage: { enabled: false },
      captions: { active: true },
      keyboard: { focused: false, global: false },
      controls: [
        "captions", // Toggle captions
        "fullscreen", // Toggle fullscreen
      ],
    };
    const hostViewport = new Plyr("#localVideo", controls);

    window.setTimeout(() => {
      hostViewport.on("enterfullscreen", (event) => {
        window.setTimeout(() => {
          this.resizeVideo();
          const videoElWrapper = $("#localVideo").parent(".plyr--video");
          if (this.angle == 90 || this.angle == 270) {
            videoEl.css("top", videoElWrapper.height() / 8);
          }
        }, 100);
      });

      hostViewport.on("exitfullscreen", (event) => {
        window.setTimeout(() => {
          videoEl.css("top", "0rem");
        }, 100);
      });
    }, 4000);
  },
};
</script>
<style lang="css" scoped>
.-rotate-270 {
  transform: rotate(-270deg) !important;
}
</style>
